import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../Firebase';

export const useFirebaseAuth = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        dispatch({
          type: '@@reactReduxFirebase/LOGIN',
          auth: {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            emailVerified: user.emailVerified,
            providerData: user.providerData,
            isLoaded: true,
            isEmpty: false,
          },
        });
      } else {
        // User is signed out
        dispatch({
          type: '@@reactReduxFirebase/LOGOUT',
          auth: {
            isLoaded: true,
            isEmpty: true,
          },
        });
      }
    });

    return () => unsubscribe();
  }, [dispatch]);
};